import { SkillCategory } from '../../types';
import { ScrollReveal } from './ScrollReveal';
import './SkillCard.css';

interface SkillCardProps {
  category: SkillCategory;
  index: number;
}

export function SkillCard({ category, index }: SkillCardProps) {
  return (
    <ScrollReveal delay={index * 0.08} className="skill-card-wrapper">
      <div className="skill-card glass-card">
        <div className="skill-card-header">
          <span className="skill-card-icon">{category.icon}</span>
          <h3 className="skill-card-title">{category.name}</h3>
        </div>
        <ul className="skill-card-list">
          {category.skills.map((skill) => (
            <li key={skill} className="skill-item">
              <span className="skill-dot" />
              {skill}
            </li>
          ))}
        </ul>
      </div>
    </ScrollReveal>
  );
}
